import { useDispatch, useSelector } from "react-redux";

import useClearDefaultAccountant from "../customHooks/useClearDefaultAccountant.js";
import useGetCompanies from "../customHooks/useGetCompanies.js";
import useChangeCompany from "./useChangeCompany.js";

const useChangeAccountant = () => {
  const company = useSelector((state) => state.company);
  const studio = useSelector((state) => state.studio);
  const dispatchAction = useDispatch();
  const main = useSelector((state) => state.main);

  const { clearDefaultAccountant } = useClearDefaultAccountant();
  const { clearDefaultCompany } = useChangeCompany();
  const { getCompanies } = useGetCompanies();

  const changeAccountantSelected = (value) => {
    if (typeof value === "string") {
      const commercialistiClientList =
        main.myType !== "STUDIO" &&
        company.companies.find((e) => {
          return e.id === main.clientIdSelected;
        });

      const arrayList =
        main.myType === "STUDIO"
          ? studio.list
          : commercialistiClientList && commercialistiClientList.commercialistiList
            ? commercialistiClientList.commercialistiList
            : [];
      let actualAccountant = arrayList.find((el) => {
        return el.id === value;
      });

      let currentAccountantCF = actualAccountant ? actualAccountant.codiceFiscale : null;

      let currentAccountantUuid = actualAccountant ? actualAccountant.uuid : null;
      if (currentAccountantCF) {
        localStorage.setItem("studioSelected", currentAccountantCF);
        localStorage.setItem("selectedAccountantID", value);
        localStorage.setItem("selectedAccountantUUID", currentAccountantUuid);
        localStorage.setItem("actualAccountantName", actualAccountant.ragioneSociale);

        dispatchAction({
          type: "changeAccountant",
          accountantUuidSelected: currentAccountantUuid,
          accountantIdSelected: value,
          accountantSelected: currentAccountantCF
        });

        if (main.myType === "STUDIO") {
          if (!main.isIntegrated) {
            clearDefaultCompany();
          }
          getCompanies(
            main.myType, arrayList, value
          );
        }
      }
    } else {
      clearDefaultAccountant();
      return;
    }
  };

  return { changeAccountantSelected };
};

export default useChangeAccountant;
